import { SharedAngular } from '@Client/@types/sharedAngular';
import IProcedureSummary from '@Shared.Angular/@types/core/contracts/queryModel/procedure/procedureSummary';
import { EmptyGuid, Guid } from '@Shared.Angular/@types/guid';
import {
  IProcedurePublishedMessage,
  IProcedureUpdatedMessage,
  PubSubEvent
} from '@Shared.Angular/@types/pubSub';
import angular from 'angular';

export default class ProceduresService {
  public static $inject = ['procedureApiService', '$q', 'pubsubService'];

  public selectedCategoryId: Guid = EmptyGuid;

  private procedures: IProcedureSummary[] = [];
  private proceduresPromise: angular.IPromise<IProcedureSummary[]>;

  constructor(
    private procedureApiService: SharedAngular.ProcedureApiService,
    private $q: angular.IQService,
    private pubsubService: SharedAngular.PubSubService
  ) {
    this.proceduresPromise = this.$q.resolve(this.procedures);
    const subscriberId = 'proceduresService';

    this.pubsubService.subscribe(
      'PROCEDURE_UPDATED',
      (event: PubSubEvent, message: IProcedureUpdatedMessage) => {
        const updatedProcedure = message.overview;
        const procedure = this.procedures.find(
          (p) => p.id === updatedProcedure.id
        );
        if (!procedure) return;

        procedure.name = updatedProcedure.name;
        procedure.description = updatedProcedure.description;
      },
      subscriberId
    );
    this.pubsubService.subscribe(
      'PROCEDURE_DELETED',
      (message: PubSubEvent, deletedProcedureId: Guid) => {
        this.procedures = this.procedures.filter(
          (procedure) => procedure.id !== deletedProcedureId
        );
        this.proceduresPromise = this.$q.resolve(this.procedures);
      },
      subscriberId
    );
    this.pubsubService.subscribe(
      'PROCEDURE_PUBLISHED',
      (event: PubSubEvent, message: IProcedurePublishedMessage) => {
        this.procedures.push(message.summary);
        this.proceduresPromise = this.$q.resolve(this.procedures);
      },
      subscriberId
    );
  }

  /** Get Procedures published to the current user from the API */
  public getRefreshedProcedures() {
    this.proceduresPromise = this.procedureApiService
      .getProceduresPublishedToCurrentUser()
      .then((response) => {
        this.procedures = response;
        return this.procedures;
      });
    return this.proceduresPromise;
  }

  /** Return cached Procedures published to the current user if any, otherwise get from the API */
  public getProcedures() {
    return this.proceduresPromise.then((procedures) => {
      if (procedures.length > 0) {
        return procedures;
      }
      return this.getRefreshedProcedures();
    });
  }
}

angular
  .module('flowingly.runner.services')
  .service('proceduresService', ProceduresService);

export type ProceduresServiceType = InstanceType<typeof ProceduresService>;
